const PRODUCT_IMAGES_BUCKET = 'product-images';

/** @deprecated use PRODUCT_IMAGES_BUCKET */
const STORAGE_BUCKET = PRODUCT_IMAGES_BUCKET;

/** Category files use the same bucket under folder `categories/` (one bucket = one storage.sql setup). */
export { PRODUCT_IMAGES_BUCKET, STORAGE_BUCKET };

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read file'));
    reader.readAsDataURL(file);
  });
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} client
 * @param {File} file
 */
export async function uploadProductImage(client, file, folder = 'products') {
  const ext =
    (file.name.split('.').pop() || 'jpg').replace(/[^a-z0-9]/gi, '').slice(0, 8) || 'jpg';
  const safeFolder = folder.replace(/[^a-z0-9-_]/gi, '').slice(0, 32) || 'products';
  const path = `${safeFolder}/${Date.now()}-${Math.random().toString(36).slice(2, 10)}.${ext}`;
  const { error } = await client.storage.from(PRODUCT_IMAGES_BUCKET).upload(path, file, {
    cacheControl: '3600',
    upsert: false,
  });
  if (error) throw error;
  const { data } = client.storage.from(PRODUCT_IMAGES_BUCKET).getPublicUrl(path);
  const url = data?.publicUrl;
  if (!url || typeof url !== 'string') {
    throw new Error('Storage did not return a public URL for the upload.');
  }
  return url;
}
